import axios, { AxiosResponse } from 'axios';

import {
    PUBLIC_ADDRESS_API_URL_ENV,
    PUBLIC_ADDRESS_API_KEY_ENV,
} from 'tools/environments';

import { GetAddressListResponse } from './types/get-address-list.type';

export const getAddressList = async (
    address: string
): Promise<AxiosResponse<GetAddressListResponse>> => {
    const apiUrl = `${PUBLIC_ADDRESS_API_URL_ENV}/autocomplete/${address}?api-key=${PUBLIC_ADDRESS_API_KEY_ENV}`;

    const response = await axios.get(apiUrl, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return response;
};
